const changeRequirement = (element, set) => {
  const group = element.get('GroupName');
  const name = element.get('Name');
  const changePOBoxRequirement = input => {
    return set('addressPOBox', !Boolean(input));
  };
  const changePOBoxRequirementCoApp = input => {
    return set('coApplicantAddressPOBox', !Boolean(input));
  };

  // const changeTradeInRequirement = input => {
  //   return set('tradeIn', Boolean(Number(input)));
  // };

  const changeAddressYearsRequirement = (input, residenceYears) => {
    const bool = Number(input) >= residenceYears ? false : true;
    return set('yearsAtAddress', bool);
  };
  const changeEmployedYearsRequirement = (input, residenceYears, employmentYears) => {
    const bool = Number(input) >= employmentYears ? false : true;
    return set('yearsAtEmployment', bool);
  };
  const changeAddressYearsRequirementCoApp = (input, residenceYears) => {
    const bool = Number(input) >= residenceYears ? false : true;
    return set('coApplicantYearsAtAddress', bool);
  };
  const changeEmployedYearsRequirementCoApp = (input, residenceYears, employmentYears) => {
    const bool = Number(input) >= employmentYears ? false : true;
    return set('coApplicantYearsAtEmployment', bool);
  };
  if (group === 'Applicant') {
    if (name === 'Address POBox') {
      return changePOBoxRequirement;
    }
    if (name === 'Address Years') {
      return changeAddressYearsRequirement;
    }
    if (name === 'Employer Years') {
      return changeEmployedYearsRequirement;
    }
  }
  if (group === 'CoApplicant') {
    if (name === 'Address POBox') {
      return changePOBoxRequirementCoApp;
    }
    if (name === 'Address Years') {
      return changeAddressYearsRequirementCoApp;
    }
    if (name === 'Employer Years') {
      return changeEmployedYearsRequirementCoApp;
    }
  }
  return () => null;
};
export default changeRequirement;